import React from 'react'

let StatisticsPage = (props) => {
    return (
        <div>Hello statistics</div>
    )
}

export default StatisticsPage;



// WEBPACK FOOTER //
// ./src/ui/pages/StatisticsPage.js